import { useState } from "react";
import { Dumbbell } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const estadosInscripcion = [
  { value: "ACTIVA", label: "Activa" },
  { value: "COMPLETADA", label: "Completada" },
  { value: "CANCELADA", label: "Cancelada" },
];

export default function Entrenamiento() {
  const [tab, setTab] = useState<"cursos" | "inscripciones">("cursos");
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);
  const { opciones: cursos } = useOpciones("/cursos", (c) => c.nombre);
  const { opciones: entrenadores } = useOpciones("/usuarios", (u) => u.nombre, (u) => ["ENTRENADOR", "ADMIN"].includes(u.rol));

  return (
    <div>
      <div className="mb-4 flex gap-2 border-b border-slate-100">
        <button
          className={`border-b-2 px-4 py-2 text-sm font-medium ${tab === "cursos" ? "border-brand-500 text-brand-600" : "border-transparent text-slate-500"}`}
          onClick={() => setTab("cursos")}
        >
          Cursos
        </button>
        <button
          className={`border-b-2 px-4 py-2 text-sm font-medium ${tab === "inscripciones" ? "border-brand-500 text-brand-600" : "border-transparent text-slate-500"}`}
          onClick={() => setTab("inscripciones")}
        >
          Inscripciones
        </button>
      </div>

      {tab === "cursos" ? (
        <CrudPage
          resource="/cursos"
          seccion="entrenamiento"
          titulo="Cursos de entrenamiento"
          icono={<Dumbbell size={20} />}
          nombreSingular="curso"
          campos={[
            { name: "nombre", label: "Nombre del curso", required: true },
            { name: "precio", label: "Precio", type: "number" },
            { name: "sesionesTotales", label: "Número de sesiones", type: "number", default: 1 },
            { name: "descripcion", label: "Descripción", type: "textarea", colSpan2: true },
          ]}
          columnas={[
            { key: "nombre", label: "Curso" },
            { key: "sesionesTotales", label: "Sesiones" },
            { key: "precio", label: "Precio", render: (r: any) => `$${r.precio.toFixed(2)}` },
          ]}
        />
      ) : (
        <CrudPage
          resource="/inscripciones"
          seccion="entrenamiento"
          titulo="Inscripciones a cursos"
          nombreSingular="inscripción"
          campos={[
            { name: "cursoId", label: "Curso", type: "select", options: cursos, required: true },
            { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
            { name: "mascotaId", label: "Mascota", type: "select", options: mascotas, required: true },
            { name: "entrenadorId", label: "Entrenador", type: "select", options: entrenadores },
            { name: "estado", label: "Estado", type: "select", options: estadosInscripcion },
          ]}
          columnas={[
            { key: "curso", label: "Curso", render: (r: any) => r.curso?.nombre },
            { key: "mascota", label: "Mascota", render: (r: any) => r.mascota?.nombre },
            {
              key: "progreso",
              label: "Progreso",
              render: (r: any) => `${r.sesionesCompletadas} / ${r.curso?.sesionesTotales ?? "-"}`,
            },
            { key: "estado", label: "Estado", render: (r: any) => <Badge color="azul">{r.estado}</Badge> },
          ]}
        />
      )}
    </div>
  );
}
